import { Card, Heading } from '@vwfs-bronson/bronson-react';

export const Section = ({ title, children }) => (
  <Card className="u-mb" element="section">
    <Heading level={4} className="u-mt-none u-mb-small">
      {title}
    </Heading>
    {children}
  </Card>
);